import React, { useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./admission.css";


const AdmissionForm = () => {
  const [formData, setFormData] = useState({
    studentName: "",
    fatherName: "",
    dob: "",
    phone: "",
    income: "",
    maritalStatus: "",
    place: "",
    permanentAddress: "",
    presentAddress: "",
    gender: "",
    lastInstitute: "",
    //field: "",
    cnic: "",
    matricRollNo: "",
    studentGroup: "",
    percentage: "",
    boardRegNo: "",
    area: "",
    obtainedMarks: "",
    totalMarks: "",
    artsCombination: "", //  new field for Arts
    scienceCombination: "",// new field for Science gdcs by erfan
    studentPhoto: "",  //to upload student picture
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
  const { name, value, files } = e.target;

  // Handle image upload
  if (files && files[0]) {
  const file = files[0];

  // Max size = !MB
  const maxSize = 1 * 1024 * 1024;

  if (file.size > maxSize) {
    alert("Image size must be less than 1MB.");
    return;
  }

  // Allow only image files
  if (!file.type.startsWith("image/")) {
    alert("Please upload a valid image file.");
    return;
  }

  const reader = new FileReader();

  reader.onloadend = () => {
    setFormData((prev) => ({
      ...prev,
      [name]: reader.result,
    }));
  };

  reader.readAsDataURL(file);
  return;
}

  const updatedForm = { ...formData, [name]: value };

  // Calculate percentage
  if (name === "obtainedMarks" || name === "totalMarks") {
    const obtained =
      name === "obtainedMarks"
        ? parseFloat(value)
        : parseFloat(updatedForm.obtainedMarks);

    const total =
      name === "totalMarks"
        ? parseFloat(value)
        : parseFloat(updatedForm.totalMarks);

    if (!isNaN(obtained) && !isNaN(total) && total > 0) {
      updatedForm.percentage = ((obtained / total) * 100).toFixed(2);
    } else {
      updatedForm.percentage = "";
    }
  }

  if (name === "studentGroup") {
    updatedForm.artsCombination = "";
    updatedForm.scienceCombination = "";
  }

  setFormData(updatedForm);
};

  const generatePDF = (data, formID) => {
    const doc = new jsPDF();
    if (data.studentPhoto) {
      doc.addImage(data.studentPhoto, "JPEG", 155, 10, 25, 25);
    }
    // doc.setFontSize(16);
    // doc.text(`Admission Form No- gdcs-000${formID}`, 20, 20);
    doc.text(
      `Admission Form No-${new Date().getFullYear()}-GDCS-000${formID}`,
      20,
      20,
    );
    const rows = [
      ["Name of Student", data.studentName],
      ["Father's Name", data.fatherName],
      ["Date of Birth", data.dob],
      ["CNIC", data.cnic],
      ["Phone Number", data.phone],
      ["Monthly Income", data.income],
      ["Marital Status", data.maritalStatus],
      ["Place of Domicile", data.place],
      ["Permanent Address", data.permanentAddress],
      ["Present Address", data.presentAddress],
      ["Gender", data.gender],
      ["Last Institute Attended", data.lastInstitute],
      //["Field", data.field],
      ["Arts Combination", data.artsCombination || "N/A"], // include in PDF
      ["Science Combination", data.scienceCombination || "N/A"], // include in PDF
      ["Matric Roll Number", data.matricRollNo],
      ["Group", data.studentGroup],
      ["Obtained Marks", data.obtainedMarks],
      ["Total Marks", data.totalMarks],
      ["Percentage", data.percentage],
      ["Board Registration No", data.boardRegNo],
      ["Area of Residence", data.area],
      ["Remarks", "_______________________"],
      ["Admission Committee Decision", "_______________________"],
      ["______________________________"],
    ];

    autoTable(doc, {
      startY: 30,
      head: [["", ""]],
      body: rows,
      theme: "grid",
      styles: { fontSize: 11 },
    });

    doc.save(`AdmissionForm_000${formID}.pdf`);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { studentGroup, percentage, area } = formData;
    const parsedPercentage = parseFloat(percentage);

    if (area.toLowerCase() !== "skardu") {
      alert("Only students from Skardu are eligible for admission.");
      return;
    }

    if (
      (studentGroup === "Science" && parsedPercentage < 60) ||
      (studentGroup === "Humanities" && parsedPercentage < 40)
    ) {
      alert(
        `Percentage requirement not met for ${studentGroup}. ${
          studentGroup === "Science" ? "Minimum is 60%" : "Minimum is 40%"
        }.`,
      );
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(
        "https://admisson.gdcs.edu.pk/admission-api/submit.php",
        // "http://localhost/new-educational-website/admission-api/submit.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        },
      );

      const result = await response.json();
      console.log("Backend response:", result);

      if (result.success) {
          alert("Admission Form Submitted!");
          const formID = result.formID; // GLOBAL ID from database by erfa
          generatePDF(formData, formID);
        } else {
        alert("Failed to submit form: " + (result.error || "Unknown error"));
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Error submitting form: " + error.message);
    }

    setIsSubmitting(false);
  };

  return (
    <div className="form-container">
      <div className="form-box">
        <h2>Admission Form</h2>
        <p>
          Please fill out the form accurately to proceed with your admission.
        </p>
        <form onSubmit={handleSubmit} className="form-grid">
          {/* --- existing fields --- */}
          <input
            type="text"
            name="studentName"
            placeholder="Name of Student"
            required
            onChange={handleChange}
          />
          {/* <input
            type="date"
            name="dob"
            placeholder="DOB"
            required
            onChange={handleChange}
          /> */}
           <div className = "DOB_labels">
            <label htmlFor="dob"> Date of Birth</label>

            <input
              type="date"
              id="dob"
              name="dob"
              required
              onChange={handleChange}
            />
          </div>
          <input
            type="text"
            name="fatherName"
            placeholder="Father's/Guardian Name"
            required
            onChange={handleChange}
          />
         
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            required
            onChange={handleChange}
          />
          <input
            type="number"
            name="income"
            placeholder="Monthly Income"
            required
            onChange={handleChange}
          />

          <select name="maritalStatus" required onChange={handleChange}>
            <option value="">Marital Status</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
          </select>

          <input
            type="text"
            name="place"
            placeholder="Place of Domicile"
            required
            onChange={handleChange}
          />
          <input
            type="text"
            name="permanentAddress"
            placeholder="Permanent Address"
            required
            onChange={handleChange}
          />

          <select name="gender" required onChange={handleChange}>
            <option value="">Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>

          <input
            type="text"
            name="presentAddress"
            placeholder="Present Address"
            required
            onChange={handleChange}
          />
          <input
            type="text"
            name="lastInstitute"
            placeholder="Last Institute Attended"
            required
            onChange={handleChange}
          />
          <input
            type="text"
            name="cnic"
            placeholder="CNIC of Father/Guardian"
            required
            onChange={handleChange}
          />
          <input
            type="number"
            name="boardRegNo"
            placeholder="Board Registration Number"
            required
            onChange={handleChange}
          />
          <input
            type="number"
            name="matricRollNo"
            placeholder="SSC-1 Roll Number"
            required
            onChange={handleChange}
          />

          <input
            type="number"
            name="obtainedMarks"
            placeholder="Obtained Marks"
            required
            onChange={handleChange}
          />
          <select
            name="totalMarks"
            required
            onChange={handleChange}
          >
            <option value="">Select Total Marks</option>
            <option value="500">510</option>
            <option value="520">520</option>
            <option value="550">550</option>
            <option value="1100">1100</option>
          </select>
          
          <input
            type="text"
            name="percentage"
            placeholder="Matric Percentage"
            value={formData.percentage}
            readOnly
          />

          <select name="studentGroup" required onChange={handleChange}>
            <option value="">Select Group for admission</option>
            <option value="Science">Science</option>
            <option value="Humanities">Humanities (Arts)</option>
          </select>

           {/* Humanities Combination */}
      {formData.studentGroup === "Humanities" && (
        <select name="artsCombination" required onChange={handleChange}>
          <option value="">Select Humanities Combination</option>
          <option value="Geography + Civics + Economics">
            Geography + Civics + Economics
          </option>
          <option value="Psychology + Education + Sociology">
            Psychology + Education + Sociology
          </option>
          <option value="Home Economics + Education + Islamic Studies">
            Home Economics + Education + Islamic Studies
          </option>
          <option value="Sociology + Civics + Islamic Studies">
            Sociology + Civics + Islamic Studies
          </option>
        </select>
      )}

      {/* Science Combination */}
      {formData.studentGroup === "Science" && (
        <select name="scienceCombination" required onChange={handleChange}>
          <option value="">Select Science Combination</option>
          <option value="Physics + Chemistry + Biology">
            Physics + Chemistry + Biology
          </option>
          <option value="Physics + Chemistry + Maths">
            Physics + Chemistry + Maths
          </option>
          <option value="Physics + Computer Science + Maths">
            Physics + Computer Science + Maths
          </option>
          <option value="Economics + Computer Science + Geography">
            Economics + Computer Science + Geography
          </option>
        </select>
      )}

          <select name="area" required onChange={handleChange}>
            <option value="">Select Area of Residence</option>
            <option value="Skardu">Skardu</option>
            <option value="Gamba">Gamba</option>
            <option value="Hoto">Hoto</option>
            <option value="411">411</option>
            <option value="Hussainabad">Hussainabad</option>
          </select>
          
          <div className="photo-upload">
            <label>Upload Picture. Size less then 1MB</label>

            <input
              type="file"
              name="studentPhoto"
              accept="jpg,.jpeg,.png"
              required
              onChange={handleChange}
            />
          </div>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit Form"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdmissionForm;
